import {fixPageAfterDel} from '@/utils/utils'
import {EditModal} from './components'

import columns from './tableConfig'
import {searchItems} from './searchFormConfig'
import store from '@/store'
import {UnbindTerminal} from '@/apis/device'
import {AppCreate, AppDelete, AppIndex, AppResetKey, AppUpdate} from '@/apis/app'
// import {dec} from '@/utils/jsencrypt'
const { decV2 } = require('@/utils/RsaUtil');
let searchCache = {}

const enumsData = store.state.enumsStore.enumsData

const { DeviceType : deviceTypes } = enumsData
export default {
  name: 'App.Index',
  components: {EditModal},
  data() {
    return {
      searchItems,
      searching: false,
      confirmGroupLoading: false,
      deviceTypes,
      columns,
      data: [],
      loading: false,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100']
      },


      showAppInfoModal: false,
      showEditModal: false,
      showBindModal: false,
      showImportModal: false,

      target: null,
      deviceStates : [
        {code: 0, name: '正常'},
        {code: 1, name: '禁用'},
        {code: 2, name: '删除'},
      ],
      templateList:[],
    }
  },
  watch: {
    '$route.params.search': async function(search) {
      if (search) {
        this.$refs.searchForm.handlerSearch()
      }
    }
  },
  created() {
    this.$nextTick(async () => {
      const { search } = this.$route.params
      this.$refs.searchForm.handlerSearch()
    })
  },
  methods: {
    // 查询模板
    async getAppIndex(page = 1, searchData) {
      try {
        this.loading = true
        // 确定搜索条件
        searchData = searchData || searchCache
        // 缓存搜索条件
        searchCache = searchData
        const {name} = searchData
        const {collection: data, pageInfo} = await AppIndex({
          name,
          page,
          perPage: this.pagination.pageSize
        })
        this.data = data
        this.pagination.current = page
        this.pagination.total = pageInfo.total
      } catch (error) {
        console.log(error)
      }
      this.loading = this.searching = false
    },
    // 翻页
    handlePageTurn(pagination, filters, sorter) {
      const {current, pageSize} = pagination
      this.pagination.pageSize = pageSize
      this.getAppIndex(current)
    },
    decodeSecret(text){
      if (text === '')
        return ''
      return decV2(text)
    },
    // 提交编辑设备的信息
    async handleSubmitEdit(value) {
      let data = Object.assign({},value)
      try {
        const { id } = data
        if (!id) {
          await AppCreate(data)
          await this.getAppIndex()
        } else {
          await AppUpdate(data)
          await this.getAppIndex(this.pagination.current)
        }
      } catch (error) {
      }
      this.handlerCloseEditModal()
    },

    // 打开编辑设备模态框
    handlerOpenEditModal(data) {
      let info = null
      if (data){
        info = Object.assign({},data)
      }
      this.target = info
      this.showEditModal = true
    },

    // 关闭编辑设备模态框
    handlerCloseEditModal() {
      this.target = null
      this.showEditModal = false
    },
    // 重置秘钥
    handlerResetAppSecret(data) {
      const {id, name} = data
      this.$confirm({
        title: '即将重置业务平台秘钥，信息如下：',
        content: h => h('div', {style: {fontSize: '12px'}}, [
          h('p', {style: {margin: '5px 0 0'}}, `名称：${name || '-'}`)
        ]),
        okText: '确认',
        okType: 'warning',
        cancelText: '取消',
        confirmLoading: true,
        onOk: () => {
          return AppResetKey(id).then(() => {
            this.pagination = fixPageAfterDel(this.pagination)
            this.getAppIndex(this.pagination.current)
          })
        }
      })
    },
    // 删除设备
    handlerDeleteApp(data) {
      const {id, name} = data
      this.$confirm({
        title: '即将删除业务平台，信息如下：',
        content: h => h('div', {style: {fontSize: '12px'}}, [
          h('p', {style: {margin: '5px 0 0'}}, `名称：${name || '-'}`)
        ]),
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        confirmLoading: true,
        onOk: () => {
          return AppDelete(id ).then(() => {
            this.pagination = fixPageAfterDel(this.pagination)
            this.getAppIndex(this.pagination.current)
          })
        }
      })
    },
    // 删除设备
    handlerUnbindStore(data) {
      const {id, sn} = data
      this.$confirm({
        title: '即将解绑店铺设备，信息如下：',
        content: h => h('div', {style: {fontSize: '12px'}}, [
          h('p', {style: {margin: '5px 0 0'}}, `SN：${sn || '-'}`)
        ]),
        okText: '解绑',
        okType: 'danger',
        cancelText: '取消',
        confirmLoading: true,
        onOk: () => {
          return UnbindTerminal(id ).then(() => {
            this.pagination = fixPageAfterDel(this.pagination)
            this.getAppIndex(this.pagination.current)
          })
        }
      })
    },
  }
}
